export const rolesChecker = {
  methods: {
    checkRole(user, allowedRoles) {
      if (user && user.role && allowedRoles && allowedRoles.length > 0) {
        return allowedRoles.includes(user.role);
      }
      return false;
    },
  },
};

export default {rolesChecker};
